import script from "./Photo.step.vue?vue&type=script&setup=true&lang=js"
export * from "./Photo.step.vue?vue&type=script&setup=true&lang=js"

import "./Photo.step.vue?vue&type=style&index=0&id=22d91796&lang=scss"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QFile,QFooter,QBtn});
